export const UPDATE_FILES_LIST = 'UPDATE_FILES_LIST'
export const UPDATE_ROOT_FOLDER = 'UPDATE_ROOT_FOLDER'
export const UPDATE_METADATA = 'UPDATE_METADATA'
export const ADD_FILE_TO_SAVE = 'ADD_FILE_TO_SAVE'
export const SAVE_FOLDER_STRUCTURE = 'SAVE_FOLDER_STRUCTURE'
export const SAVE_FOLDER_STRUCTURE_SUCCESS = 'SAVE_FOLDER_STRUCTURE_SUCCESS'
export const SAVE_FOLDER_STRUCTURE_FAILURE = 'SAVE_FOLDER_STRUCTURE_FAILURE'
export const SEND_NOTIFICATION_FOLDER = 'SEND_NOTIFICATION_FOLDER'
export const SAVE_FILES_IDS = 'SAVE_FILES_IDS'
